<template>
  <div>
    <div class="mt-4 ml-1">
      <el-row>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
            >管理中心</el-breadcrumb-item
          >
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/admin/user/profile' }"
            >用户列表</el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span class="text-primary">新增用户信息</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </el-row>
      <el-card class="my-4 mx-1">
        <div slot="header">
          <span class="font-weight-bold text-primary">新增用户</span>
        </div>
        <el-form
          label-width="120px"
          :model="userInfo"
          :rules="rules"
          status-icon
          class="font-weight-bold w-50"
          ref="ValidateForm"
        >
          <el-form-item label="用户名" prop="username">
            <el-input
              type="text"
              v-model="userInfo.username"
              auto-complete="off"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="userInfo.password"
              auto-complete="off"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="昵称" prop="nickname">
            <el-input
              type="text"
              v-model="userInfo.nickname"
              auto-complete="off"
              placeholder="请输入昵称"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phoneNumber">
            <el-input
              type="text"
              v-model="userInfo.phoneNumber"
              auto-complete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="userInfo.status">
              <el-radio :label="true" border>激活</el-radio>
              <el-radio :label="false" border>禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="角色配置">
            <el-checkbox-group v-model="selectedRolesIds">
              <el-checkbox
                v-for="(role, i) in roles"
                :key="i"
                :label="role.roleId"
                >{{ role.nameZh }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitUserInfoForm(userInfo, 'ValidateForm')"
              >立即提交</el-button
            >
            <el-button @click="cancelSubmitForm()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "AddAdminUser",
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!this.isCellPhone(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      adminPermissions: this.$store.state.adminPermissions,
      userInfo: {},
      selectedRolesIds: [],
      roles: [],
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
        nickname: [
          { required: true, message: "昵称不能为空", trigger: "blur" }
        ],
        phoneNumber: [
          {
            required: true,
            validator: checkPhone,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    //检查手机号
    isCellPhone(val) {
      return /^1([345678])\d{9}$/.test(val);
    },
    getRoles() {
      this.axios.get("/adminRole/admin/getRoleList", {}).then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.roles = resp.data.data;
        }
      });
    },
    cancelSubmitForm() {
      this.$router.push({ name: "UserInfo" }).catch();
    },
    submitUserInfoForm(userInfo, formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.axios
            .post("/adminUser/admin/addUser", {
              username: userInfo.username,
              password: userInfo.password,
              nickname: userInfo.nickname,
              phoneNumber: userInfo.phoneNumber,
              status: userInfo.status,
              roles: this.selectedRolesIds
            })
            .then(resp => {
              if (resp && resp.data.code === 10000 && resp.data.success) {
                this.$notify({
                  title: "成功",
                  message: "添加成功",
                  type: "success"
                });
                this.$router.push({ name: "UserInfo" }).catch();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: "添加失败！"
                });
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
